import React from 'react';
import PropTypes from 'prop-types';
import { BorderlessIframe, ResponsiveIframeWrapper } from '../styled/iframe';
/*
  This component can be used to return a simple Google Maps iframe.
  Use components/google-map if customisation such as custom markers,
  non-standard click interactions or any other feature offered by
  the Google Maps API are required.
*/

const GoogleMapIframe = ({ placeID, address }) => {
  const baseSrcURL = 'https://www.google.com/maps/embed/v1/place';
  let iFrameSrc;

  if (placeID) {
    iFrameSrc = `${baseSrcURL}?key=${process.env.GOOGLE_MAPS_API_KEY}&q=place_id:${placeID}`;
  } else if (address) {
    iFrameSrc = `${baseSrcURL}?key=${
      process.env.GOOGLE_MAPS_API_KEY
    }&q=${encodeURI(address)}`;
  }

  return (
    iFrameSrc && (
      <ResponsiveIframeWrapper>
        <BorderlessIframe src={iFrameSrc} title="Map" />
      </ResponsiveIframeWrapper>
    )
  );
};

GoogleMapIframe.propTypes = {
  placeID: PropTypes.string,
  address: PropTypes.string,
};

export default GoogleMapIframe;
